import { Grid } from "@mui/material";
import { ExpandableSection } from "../ExpandableSection";
import { MediaTitleFilter } from "../MediaTitleFilter";
import { CreativeCard } from "../CreativeCard";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

const Section = ({ items, classes }) => {
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  const [mediaTitleChoices, setMediaTitleChoices] = useState([]);
  const [teaserMediaTitleFilter, setTeaserMediaTitleFilter] = useState([]);

  useEffect(() => {
    if (Array.isArray(items)) {
      const teaserMediaTitles = new Set();
      items.forEach((c) => {
        if (Array.isArray(c.media_title_codes)) {
          c.media_title_codes.forEach((mt) => {
            teaserMediaTitles.add(mt);
          });
        }
      });

      setMediaTitleChoices(Array.from(teaserMediaTitles));
      setTeaserMediaTitleFilter(Array.from(teaserMediaTitles));
    }
  }, [items]);

  const toggleMediaTitle = (name) => () => {
    const index = teaserMediaTitleFilter.indexOf(name);
    if (index === -1) {
      setTeaserMediaTitleFilter([...teaserMediaTitleFilter, name]);
    } else {
      setTeaserMediaTitleFilter(
        teaserMediaTitleFilter.filter((t) => t !== name),
      );
    }
  };
  return (
    <ExpandableSection title="Teaser A/B Tests" classes={classes}>
      <MediaTitleFilter
        mediaTitleChoices={mediaTitleChoices}
        teaserMediaTitleFilter={teaserMediaTitleFilter}
        toggleMediaTitle={toggleMediaTitle}
        dfpMediaTitleLabels={dfpMediaTitleLabels}
        classes={classes}
      />
      <Grid item xs={12} sm={12} md={12}>
        {items
          ?.filter((creative) =>
            creative.media_title_codes?.some((c) =>
              teaserMediaTitleFilter.includes(c),
            ),
          )
          .toSorted((a, b) => b.ctr - a.ctr)
          .map((creative) => (
            <CreativeCard
              key={creative.id}
              creative={creative}
              isLoggedIn={isLoggedIn}
              dfpMediaTitleLabels={dfpMediaTitleLabels}
              classes={classes}
            />
          ))}
      </Grid>
    </ExpandableSection>
  );
};

const dfpMediaTitleLabels = {
  "20minuten-front": "20 Minuten Front",
  "20minuten-wettbewerb": "20 Minuten Wettbewerb",
  "20minuten-DE": "20 Minuten",
  "20minutes-FR": "20 minutes",
  "20minuti-Tio-IT": "tio",
  Annabelle: "Annabelle",
  Bilan: "Bilan",
  "encore-DE": "Encore",
  "encore-FR": "Encore",
  Femina: "Femina",
  FUW: "Finanz und Wirtschaft",
  "NN-Baslerzeitung": "Basler Zeitung",
  "NN-Berneroberlaender": "Berner Oberländer",
  "NN-Bernerzeitung": "Berner Zeitung",
  "NN-Derbund": "Der Bund",
  "NNf-24heures": "24 heures",
  "NNf-Lematin": "Le Matin",
  "NNf-Tdg": "Tribune de Genève",
  "NN-Langenthalertagblatt": "Langenthaler Tagblatt",
  "NN-Tagesanzeiger": "Tages Anzeiger",
  "NN-Thunertagblatt": "Thuner Tagblatt",
  NNz_Landbote: "Der Landbote",
  NNz_ZuercherUnterlaender: "Zürcher Unterländer",
  NNz_ZuerichseeZeitung: "Zürichsee Zeitung",
};

export default Section;
